import { Edit, SimpleForm, TextInput } from 'react-admin';

const SliderEdit = () => (
    <Edit>
        <SimpleForm>
            <TextInput source="id" />
            <TextInput source="text" />
        </SimpleForm>
    </Edit>
);

export default SliderEdit;